import Vue from 'vue';
import Vuex from 'vuex';
// assets
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
// // modules
import auth from './modules/auth';
import corporation from './modules/corporation';
import user from './modules/user';
import userGroup from './modules/userGroup';
import role from './modules/role';
import permission from './modules/permission';
import project from './modules/project';
import device from './modules/device';
import structure from './modules/structure';
import measuringPoint from './modules/measuringPoint';
import measuringAttribute from './modules/measuringAttribute';
import bim from './modules/bim';
import alertRule from './modules/alertRule';
import stat from './modules/stat';
import report from './modules/report';
import chartSetting from './modules/chartSetting';

Vue.use(Vuex);

const state = {
  socket: null, // Socket.IO对象
  caluploads: [], // 已上传校准文件
  isCollapse: true,
  isFullscreen: false,
  breadcrumbItems: [],
  loading: false,
  version: '',
  // 全局时间范围
  globalPeriod: [],
};

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  modules: {
    auth,
    corporation,
    user,
    userGroup,
    role,
    permission,
    project,
    device,
    structure,
    measuringPoint,
    measuringAttribute,
    bim,
    alertRule,
    stat,
    report,
    chartSetting,
  },
});

